/**
 * DealEasy (prix dégressifs) ajoute au panier avec son propre bouton, puis redirige vers /cart :
 * l'application ne connaît pas le tiroir panier d'Horizon.
 *
 * 1. Avant que DealEasy traite l'ajout, son action « aller au panier » est remplacée par
 *    « rafraîchir le panier » (pas de redirection). Écoute en phase de capture sur window :
 *    elle passe avant l'écouteur de DealEasy, posé sur document.
 * 2. Une fois l'ajout fait, l'événement standard d'ajout est émis : le tiroir se met à jour
 *    et s'ouvre comme pour le bouton du thème (réglage « ouvrir le tiroir après ajout »).
 *
 * Ne touche que ce thème : le réglage DealEasy de l'application reste inchangé.
 */
import { signalerAjoutPanier } from '@theme/pop-cart';

window.addEventListener(
  'lbDealeasyAddProductsToCart',
  (event) => {
    const detail = /** @type {CustomEvent} */ (event).detail;
    if (!detail || typeof detail !== 'object') return;
    detail.settings = { ...(detail.settings || {}), atcBtnAction: 'refresh_cart' };
  },
  true
);

window.addEventListener('lb-dealeasy-qty-selector-added-to-cart', (event) => {
  const detail = /** @type {CustomEvent} */ (event).detail;
  if (detail?.status !== 'success') return;
  signalerAjoutPanier('pop-dealeasy');
});
